import { Box, CircularProgress } from '@mui/material';

import { BillableHoursProposalProps } from '~/data/proposals';
import { useBillableHoursProposalsLayout } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposals/components/EmployeeBillableHoursProposalsLayout/useBillableHoursProposalsLayout';
import {
  EmployeeProposalsLayout,
  EmployeeProposalsLayoutProps,
} from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposals/components/EmployeeProposalsLayout/component';

export const EmployeeBillableHoursProposalsLayout = (
  props: EmployeeProposalsLayoutProps<BillableHoursProposalProps>,
) => {
  const { newProposal, ...passProps } = props;
  const { isLoading, ...billableHoursProps } =
    useBillableHoursProposalsLayout(props);

  const layoutProps = {
    ...passProps,
    ...billableHoursProps,
  };

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  return <EmployeeProposalsLayout {...layoutProps} />;
};
